import { SHOP_API_URLS, STATE_API_URLS } from "@/config/apiConfig";
import { ShopResponse } from "@/types/shop";


// Helper function to get auth token
const getAuthToken = (): string => {
  if (typeof window === "undefined") return "";
  const token = localStorage.getItem("token");
  return token || "";
};

// Get All Shops
export const  getAllShops = async () => {
  const token = getAuthToken();
  const response = await fetch(SHOP_API_URLS.GET_ALL_SHOPS, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (!response.ok) throw new Error("Failed to get all shops");

  const result = await response.json();
  // Frappe API can return { data: [...] } or { data: { 0: {...}, 1: {...} } } (object with numeric keys)
  const raw = result.data ?? result;
  const data: ShopResponse[] = Array.isArray(raw) ? raw : raw && typeof raw === 'object' ? Object.values(raw) : [];
  return data;
};

// Get Shop by ID
export const getShopById = async (name: string) => {
    const token = getAuthToken();
    const response = await fetch(SHOP_API_URLS.GET_SHOP_BY_ID.replace(':name', name), {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
        },
    });
    if (!response.ok) throw new Error("Failed to get shop by id");
    const result = await response.json();
    // Frappe API returns data in { data: {...} } format
    const data: ShopResponse = result.data || result;
    return data;
}

// Create Shop
export const createShop = async (shop: any) => {
    const token = getAuthToken();
    const response = await fetch(SHOP_API_URLS.CREATE_SHOP, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
        },
        body: JSON.stringify(shop),
    });
    if (!response.ok) throw new Error("Failed to create shop");
    const data: any = await response.json();
    return data;

}

// Update Shop
export const updateShop = async (name: string, shop: any) => {
    const token = getAuthToken();
    const response = await fetch(SHOP_API_URLS.UPDATE_SHOP.replace(':name', name), {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
        },
        body: JSON.stringify(shop),
    });
    if (!response.ok) throw new Error("Failed to update shop");
    const data: any = await response.json();
    return data;
}

// Delete Shop
export const deleteShop = async (name: string) => {
    const token = getAuthToken();
    const response = await fetch(SHOP_API_URLS.DELETE_SHOP.replace(':name', name), {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
        },
    });
    if (!response.ok) throw new Error("Failed to delete shop");
    const data: any = await response.json();
    return data;
}
